import React, { Component } from 'react';
import { Link } from 'react-router';
import Helmet from 'react-helmet';

import InputText from '../../components/form/input/text';
import InputCheckbox from '../../components/form/input/checkbox';
import InputSubmit from '../../components/form/input/submit';
import ContentBlock from '../../components/account/block/content';
import {
	formIsValid,
	VALIDATE_EMAIL,
	VALIDATE_MIN_LENGTH,
} from '../../components/form/validate';
import Spinner from '../../components/svg/spinner';

import { redirectToPathIf } from '../../utils/authorization';
import { accountRoute } from '../../routes';

import { login } from '../../actions/users';
import axios from 'axios';
import baseUrl from '../../utils/baseUrl';

import connect from '../../utils/connect';
import translate from '../../utils/translate';

import FBAuth from '../../utils/social/fb';
import GoogleAuth from '../../utils/social/google';
import TwitterAuth from '../../utils/social/twitter';

class AccountActivate extends Component {

	constructor(props) {
		super();

		this.FB = new FBAuth();
		this.GGL = new GoogleAuth();
		this.TWT = new TwitterAuth();

		this.state = {
			msg: 0,
			error: false,
			waiting: false,
			fieldValidity: {
				emailInvalid: false,
				passwordInvalid: false,
			},
		};
	}

	componentWillMount() {
		redirectToPathIf(this.props.dispatch, accountRoute(''), this.props.users.isLoggedIn());
		redirectToPathIf(this.props.dispatch, accountRoute(''), !this.props.router.params.hash);

		this.FB.load();
		this.GGL.load();

		if (this.props.router.params.hash) {
			setTimeout(() => {
				this.props.dispatch(this.confirmEmail(this.props.router.params.hash));
			}, 2000);
		}
	}

	componentWillReceiveProps(nProps, nState) {
		redirectToPathIf(nProps.dispatch, this.props.router.location.query.returnTo || accountRoute(''), nProps.users.isLoggedIn());

		if (nProps.errors.error) {
			this.setState({...nState, waiting: false});
		}
	}

	render() {
		return (
			<section className='account-flow'>
				<Helmet title='The FWA - Account activation' />

				<header className='span14 account-flow__head'>
					<div className='span7 span13-mobile push5-desktop'>
						<h1 className='account-flow__head__title'>
							{translate('account/activate/header' + this.state.msg)}
						</h1>
						<h2 className='account-flow__head__title account-flow__head__title--faded'>
							{this.state.error ? this.state.error : translate('account/activate/subheader' + this.state.msg)}
						</h2>
					</div>
				</header>

				<ContentBlock title={translate('account/activate/aside')}>
					{!this.state.msg && (
						<div className='span6 account-flow__form'>
							<Spinner size='128px' />
						</div>
					)}
					{!!this.state.msg && this.renderLogin()}
					{!!this.state.msg && this.renderSocialLogin()}
					<div className='cf'></div>
				</ContentBlock>
			</section>
		);
	}

	renderLogin() {
		return (
			<div className='span4 span6-tablet span14-mobile account-flow__form'>
				<header className='block-label--relative'>
					{translate('account/activate/formtitle')}
				</header>
				<form action='' onSubmit={(e) => this.handleSubmit(e)} noValidate={true}>
					<InputText
						className={'span3 span4-tablet span11-mobile account-flow__form__input'}
						name='email'
						ref='email'
						type='email'
						required='required'
						placeholder='Email'
						manualValidate={true}
						validate={[
							{rule: VALIDATE_EMAIL},
						]}
					/>

					<span></span>

					<InputText
						className={'span3 span4-tablet span11-mobile account-flow__form__input'}
						name='password'
						ref='password'
						type='password'
						required='required'
						placeholder='Password'
						pattern='^.{6,}$'
						manualValidate={true}
						validate={[
							{rule: VALIDATE_MIN_LENGTH, params: 6},
						]}
					/>

					<InputCheckbox name='remember' ref='remember'>Remember me next time</InputCheckbox>

					<InputSubmit name='Sign in' waiting={this.state.waiting} className={'account-flow__form__submit' + (this.state.waiting ? '' : ' button--go')} />

				</form>
				<div className='account-flow__form__btw'>
					<Link to={accountRoute('/recover')} className='account-flow__form__btw__link'>Forgot password</Link>
					<Link to={accountRoute('/register')} className='account-flow__form__btw__link'>Sign up</Link>
				</div>
			</div>
		);
	}

	renderSocialLogin() {
		return (
			<div className='span3 span4-tablet span100p-mobile span account-flow__social'>
				<header className='block-label--relative'>
					{translate('account/activate/social')}
				</header>

				<div>
					<button className='button--fb account-flow__social__button' onClick={this.loginFB.bind(this)}>Facebook</button>
				</div>
				<div>
					<button className='button--twt account-flow__social__button' onClick={this.loginTWT.bind(this)}>Twitter</button>
				</div>
				<div>
					<button className='button--ggl account-flow__social__button' onClick={this.loginGGL.bind(this)}>Google</button>
				</div>
			</div>
		);
	}

	confirmEmail(token) {
		let _this = this;
		return function(dispatch) {
			//dispatch(requestData());
			return axios.get(baseUrl + '/api/account/confirm', {
				params: {
					hash: token,
				},
			})
			.then((response) => {
				_this.setState({..._this.state, msg: 1 });
			})
			.catch((response) => {
				// do something on fail?!
				let error = false;
				if (response.data.hasOwnProperty('message')) {
					error = response.data.message;
				}

				_this.setState({..._this.state, msg: 2, error: error });
			});
		};
	}

	handleSubmit(e) {
		e.preventDefault();
		let fieldsToCheck = [
			this.refs.email,
			this.refs.password,
		];

		if (formIsValid(fieldsToCheck)) {
			this.props.dispatch(login(this.refs.email.value(), this.refs.password.value(), this.refs.remember.value, this.stopWaiting.bind(this), this.stopWaiting.bind(this)));
			this.setState({...this.state, waiting: true});
		} else {
			this.setState({...this.state, waiting: false});
		}
	}

	stopWaiting() {
		this.setState({...this.state, waiting: false});
	}

	loginFB() {
		this.FB.login(this.props.dispatch);
	}

	loginGGL() {
		this.GGL.login(this.props.dispatch);
	}

	loginTWT() {
		this.TWT.login(this.props.dispatch);
	}
}

export default connect(AccountActivate);



/** WEBPACK FOOTER **
 ** ./frontend/containers/account/activate.js
 **/